<template>
	<div v-if="channel && channel.isLoaded">
		<div id="d21-imprint">
			<a v-if="channel.Imprint && channel.Imprint.IsActive && channel.Imprint.File" :href="'https://api-default.tocc.dirs21.de/v1/cdn' + channel.Imprint.File.URI" target="imprint">{{ T("imprint") }}</a>
			<div class="d21-language-select">
				<d21-select :list="this.languages"></d21-select>
			</div>
			<div v-if="isLoginVisible" class="d21-profile-login">
				<div v-if="profile.Token">
					<span @click="navigateToProfile">
						<i class="material-icons account">account_circle</i>
						<font>{{ profile.Contact.GivenName[0] }} {{ profile.Contact.LastName[0] }}</font>
					</span>
				</div>
				<button class="btn btn-primary" @click="showProfileLogin" v-else>
					<span>{{ T("ticketing_login") }}</span>
				</button>
			</div>
		</div>

		<section class="d21-section">
			<router-view />
		</section>

		<Back />

		<Notifications />

		<Modal name="login" :title="T('ticketing_login')" :actions="loginModalActions">
			<ModalLogin @update:content="updateLoginFields($event)" />
		</Modal>

		<Modal name="register" :title="T('register')" :actions="registerModalActions" @hide="resetRegister">
			<ModalRegister />
		</Modal>

		<Modal name="forgot-password" :title="T('ticketing_forgot_password')" :actions="forgotPasswordModalActions">
			<div class="mdl-grid" v-if="isResetMailSent">
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group success">
					<i class="material-icons">check_circle</i>
					{{ T("ticketing_email_reset_confirmation", username) }}
				</div>
			</div>
			<ModalForgotPassword v-else @update:content="updateLoginFields($event)" />
		</Modal>

		<Modal name="reset-password" :title="T('ticketing_reset_password')" :actions="resetPasswordModalActions">
			<ModalResetPassword />
		</Modal>

		<Modal name="password" :title="T('ticketing_password')" :actions="passwordModalActions" persistent>
			<div class="mdl-grid">
				<label class="text-header">
					{{ T("enter_password") }}:
				</label>
				<div class="mdl-cell mdl-cell--12-col form-group">
					<input v-model="reservation.Protection.Password" type="password" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('password')" />
				</div>
				<div v-if="passwordIsInvalid" class="mdl-cell mdl-cell--12-col form-group">
					<span v-if="passwordIsInvalid" class="error">{{ T("password_incorrect") }}</span>
				</div>
				<div class="mdl-cell mdl-cell--12-col form-group">
				</div>
				<div class="d21-modal-buttons">
					<button class="btn btn-primary" @click="onPassword">
						<span>{{ T("login") }}</span>
					</button>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import appStart from "@/mixins/appStart";
	import Back from "./components/ui/back.vue";
	import Notifications from "./components/ui/notifications.vue";
	import Modal from './components/modal.vue';
	import ModalLogin from './components/modals/modal-login.vue';
	import ModalRegister from './components/modals/modal-register.vue';
	import ModalForgotPassword from "./components/modals/modal-forgot-password.vue";
	import ModalResetPassword from "./components/modals/modal-reset-password.vue";

	import {
		EventBus
	} from "./scripts/_eventBus.js";

	export default {
		mixins: [appStart],
		name: "d21-app-content",
		components: {
			Back,
			Notifications,
			Modal,
			ModalLogin,
			ModalRegister,
			ModalForgotPassword,
			ModalResetPassword
		},
		data() {
			return {
				passwordIsInvalid: false,
				languages: ['de-DE', 'en-US'],
				doRegisterUser: false,
				doPasswordForgotten: false,
				showLogin: false,
				showRegister: false,
				showForgotPassword: false,
				showResetPassword: false,
				username: '',
				password: '',
				isLoginPending: false,
				registerDone: false,
				isResetMailSent: false,
				hasError: false,
			};
		},
		computed: {
			loginModalActions() {
				return [{
					text: this.T("cancel"),
					onClick: () => {
						this.$modals.hide("login");
						this.resetLoginCredentials();
					}
				}, {
					text: this.T("ticketing_login"),
					onClick: () => {
						this.login();
					},
					isPrimary: true,
					loadingEvent: "loginPendingStatus"
				}];
			},
			registerModalActions() {
				if (this.registerDone) {
					return [{
						text: this.T('close'),
						onClick: () => {
							this.$modals.hide('register');
							this.resetRegister();
						},
						isPrimary: true,
					}];
				}
				return [{
					text: this.T("cancel"),
					onClick: () => {
						this.$modals.hide("register");
					}
				}, {
					text: this.T("register"),
					onClick: () => {
						EventBus.$emit("onProfileRegister");
					},
					isPrimary: true,
					loadingEvent: "registerPendingStatus",
				}];
			},
			forgotPasswordModalActions() {
				return [{
					text: this.T("cancel"),
					onClick: () => {
						this.$modals.hide("forgot-password");
					}
				}, {
					text: this.T("ticketing_reset"),
					onClick: () => {
						this.sendResetPasswordRequest();
					},
					isPrimary: true,
					loadingEvent: "resetPasswordRequestStatus"
				}];
			},
			resetPasswordModalActions() {
				return [{
					text: this.T("ticketing_to_login"),
					onClick: () => {
						this.$modals.hide("reset-password");
						this.$modals.show("login");
					},
					isPrimary: true
				}];
			},
			passwordModalActions() {
				return [];
			},
			isLoginVisible() {
				return this.channel.UserProfile && this.channel.UserProfile.IsActive && !this.$route.path.includes("login");
			}
		},
		mounted() {
			this.checkForCookieLogin();
			let groups = document.querySelectorAll(".form-group input");

			for (let i = 0; i < groups.length; i++) {
				let group = groups[i];

				group.addEventListener("focus", function (e) {
					e.target.parentNode.classList.add("active");
				});

				group.addEventListener("blur", function (e) {
					e.target.parentNode.classList.remove("active");
				});
			}

			EventBus.$on("loginPendingStatus", (status) => {
				this.isLoginPending = status;
			});
			EventBus.$on("register:isDone", (status) => {
				this.registerDone = status;
			});
		},
		methods: {
			login() {
				EventBus.$emit("loginPendingStatus", true);
				const data = {
					Login: this.username,
					Password: this.password
				};
				this.loadProfile(data, () => {
					this.$modals.hide("login");
				}, null, () => {
					EventBus.$emit("loginPendingStatus", false);
				});
			},
			resetRegister() {
				this.registerDone = false;
			},
			updateLoginFields(event) {
				this.username = event.username;
				this.password = event.password;
			},
			resetLoginCredentials() {
				this.username = "";
				this.password = "";
			},
			showProfileLogin() {
				this.$modals.show("login");
			},
			showProfileRegister() {
				this.doRegisterUser = true;
				this.doPasswordForgotten = false;
			},
			sendResetPasswordRequest() {
				this.isLoginPending = true;
				EventBus.$emit("resetPasswordRequestStatus", true);
				this.apiRequest(`/profile/${this.$route.params.channel}/passwordreset?email=${this.username}`, null, "GET", result => {
					this.hasError = !result.Meta.IsValid;
					this.isResetMailSent = result.Meta.IsValid;
					this.isLoginPending = false;

					EventBus.$emit("resetPasswordRequestStatus", false);
				}, error => {});
			},
			onProfileRegister() {
				EventBus.$emit("onProfileRegister", null);
			},
			onProfileLogin() {
				EventBus.$emit("onProfileLogin", null);
			},
			onPasswordForgotten() {
				EventBus.$emit("onPasswordForgotten", null);
			},
			onShowForgotPassword() {
				this.doRegisterUser = false;
				this.doPasswordForgotten = true;
			},
			navigateToProfile() {
				if (this.$route.path.includes("profile/home")) return;

				this.$router.push(`/${this.$route.params.channel}/profile/home`);
			}
		}
	};
</script>